require('../../modules/es.array.iterator');
require('../../modules/es.object.to-string');
require('../../modules/es.weak-map');
var path = require('../../internals/path');

module.exports = path.WeakMap;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/weak-map/index.js
// module id = 590
// module chunks = 0 1